import { useRouter } from 'next/router';
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { isStandalone } from '@common/contexts/PwaContext';
import { Any } from '@common/defs/types';

if (typeof window !== 'undefined') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY || '', {
    person_profiles: 'always',
    api_host: '/ingest',
    loaded: (posthog) => {
      posthog.debug(process.env.NEXT_PUBLIC_ENVIRONMENT !== 'prod');

      // ✅ Exposer globalement pour debug en console
      if (typeof window !== 'undefined') {
        (window as Any).posthog = posthog;
      }
    },
    capture_pageview: false,
    capture_pageleave: true,
  });
  const isPwa = isStandalone();
  posthog.register({
    display_mode: isPwa ? 'pwa' : 'browser',
  });
}

const PostHogProvider = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      if (typeof window !== 'undefined') {
        posthog.capture('$pageview');
      }
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return <PHProvider client={posthog}>{children}</PHProvider>;
};

export default PostHogProvider;
